module.exports = __webpack_public_path__ + "media/fonts/Aleo-Light-fb4a30f7bb7b57d24cfe24dcfb4343d3.ttf";